import React from "react";
import styled from "styled-components";
import { actionStyle, ActionVariant } from "../../styles/controls";
interface ButtonProps {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "outline" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  className?: string;
}
const StyledButton = styled.button<{
  $variant: ActionVariant;
  $size: string;
  $full: boolean;
}>`
  ${actionStyle}width:${(p) => (p.$full ? "100%" : "auto")};
  min-height: ${(p) =>
    p.$size === "sm" ? "34px" : p.$size === "lg" ? "50px" : "44px"};
  padding: ${(p) =>
    p.$size === "sm"
      ? "7px 12px"
      : p.$size === "lg"
        ? "13px 24px"
        : "11px 18px"};
  font-size: ${(p) => (p.$size === "sm" ? "14px" : "15px")};
`;
const Spinner = styled.span`
  width: 15px;
  height: 15px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: button-spin 0.7s linear infinite;
  @keyframes button-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
export default function Button({
  children,
  variant = "primary",
  size = "md",
  disabled = false,
  loading = false,
  fullWidth = false,
  onClick,
  type = "button",
  className,
}: ButtonProps) {
  return (
    <StyledButton
      $variant={variant === "outline" ? "secondary" : variant}
      $size={size}
      $full={fullWidth}
      disabled={disabled || loading}
      aria-busy={loading}
      onClick={onClick}
      type={type}
      className={className}
    >
      {loading && <Spinner />}
      {children}
    </StyledButton>
  );
}
